<template>
    <div style="width: 320px;display: flex;justify-content: center;">
        <div
            style="width:100%; background-color: white;border-radius: 4px;box-shadow: inset;font-size: 12px;padding: 10px;line-height: 20px;border: 1px solid #E8EBF0 ;">

            <div  class="msg-title" style="display: flex; justify-content: space-between;border-bottom: 1px solid #f3f3f3;margin-bottom: 10px;padding-bottom: 10px;">
                <div  style="font-size: 14px;font-weight: 600;">
                    <!-- {{ itemMsgQueyobj.content }} -->
                    {{ itemMsgQueyobj.content.conNo || itemMsgQueyobj.content.pcNo || itemMsgQueyobj.content.miNo || itemMsgQueyobj.content.gDeliverynum || itemMsgQueyobj.content.minvoConNo || itemMsgQueyobj.content.payNo || itemMsgQueyobj.content.miNo }}

                </div>
                <div>
                   <!-- {{ itemMsgQueyobj.labelColor }} -->
                   <el-tag 
										style="height: 24px;vertical-align: middle;line-height: 24px;padding: 0 8px;margin-right: 4px;"
											:color="itemMsgQueyobj.labelColor+'10'" 
											:style="{
												color: itemMsgQueyobj.labelColor+'FF',
												borderColor: itemMsgQueyobj.labelColor+'50'
											}"
										>
											{{ itemMsgQueyobj.templateName }}
										</el-tag>
                </div>
            </div>
            <!-- {{ itemMsgQuey }}
            _____________________
            {{ itemMsgQueyobj }} -->
            <div v-for="(key) in toKeys(itemMsgQueyobj.template)" :key="key" style="display: flex;margin-bottom: 8px;">
                <div style="width: 80px;text-align: right;margin-right: 5px;color: #9E9E9E;font-size: 14px;">
                    {{ itemMsgQueyobj.template[key] }}</div>
                :
                <span style="margin-left: 5px;width: 230px;font-size: 14px;">
                    {{ itemMsgQueyobj.content[key] }}
                </span>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChatMsgQuey",
    props: ['itemMsgQuey'],
    computed: {
        itemMsgQueyobj() {
            let itemMsgQueyObj = { ...this.itemMsgQuey }
            if (itemMsgQueyObj.content) {
                let content = JSON.parse(itemMsgQueyObj.content);
                itemMsgQueyObj.template = JSON.parse(content.template);
                itemMsgQueyObj.content = JSON.parse(content.content);
                itemMsgQueyObj.labelColor = content.labelColor;
                itemMsgQueyObj.templateName = content.templateName;
                return itemMsgQueyObj;
            } else {
                return { template: {}, content: {} }
            }
        }
    },
    methods: {
        isLast(template, index) {
            return index == Object.keys(template).length - 1 ? true : false;
        },
        toKeys(jsonObject) {
            return Object.keys(jsonObject);
        },

    }

}
</script>

<style scoped lang="scss"></style>